import { masterChefV3Addresses } from '@pancakeswap/farms'
import { DEPLOYER_ADDRESSES } from '@pancakeswap/v3-sdk'
import { V3_QUOTER_ADDRESSES } from '@pancakeswap/smart-router/evm'

export default {
  masterChef: {
    97: '0xED65bD05ccd0fF8cc6E46B9e7Ee2d5638205bDBa',  // ours
    56: '0xb1c2C30b339C8666530d7E1dbef2F2ba20295Ec2', // ours
  },
  masterChefV3: masterChefV3Addresses,
  masterChefV1: {
    97: '0xBDC5104a3C52A3f49f0324696f9Bb77E41516De7',
    56: '0x3d03d12F95Bdc4509804f9Bcee4139b7789DC516', // ours
  },
  sousChef: {
    97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    56: '0x699BD7e47696a0334c0503511CD213f9454A6C79', // ours
  },
  lotteryV1: {
    97: '0x5B48Ef25B9251Ba02c2beE9b808ABB1e346AE6cD', // ours
    56: '0x9D4823aa89Dc33ED53d930CB554AFFc58B0c9852', // ours
  },
  lotteryV2: {
    97: '0x5B48Ef25B9251Ba02c2beE9b808ABB1e346AE6cD', // v1
    56: '0xE342Aefc383f2DcD10A52B1e67CF8822aE7a345a', // ours
  },  
  busdlottery: {
    97: '0xCc6643893A8F5754F93f3aAf04477D057759129A', // ours
    56: '0xAA7261b4fAEE6976CFB4791083505b0f8A8Eb809', // ours
  },
  multiCall: {
    1: '0x07394f1a59c0d1833cf0e439ccbe4dbd09769868',
    4: '0x07394f1a59c0d1833cf0e439ccbe4dbd09769868',
    5: '0x07394f1a59c0d1833cf0e439ccbe4dbd09769868',
    56: '0x07394f1a59c0d1833cf0e439ccbe4dbd09769868', // ours
    97: '0x07394f1a59c0d1833cf0e439ccbe4dbd09769868',
    280: '0xF9cda624FBC7e059355ce98a31693d299FACd963',
    324: '0xF9cda624FBC7e059355ce98a31693d299FACd963',    
  },
  pancakeProfile: {
    56: '0x050E19e136ceB9ACa4A8a5FbDf28bc83ed9EBeBD', // ours
    97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeBunnies: {
    56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '0x',
  },
  pointCenterIfo: {
    56: '0x319a79e3485c981f4b123d17dbe427800081c603', // ours
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    56: '0xFee8A195570a18461146F401d6033f5ab3380849',
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetitionEaster: {
    56: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    97: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  tradingCompetitionFanToken: {
    56: '0xA8FECf847e28aa1Df39E995a45b7FCfb91b676d4',
    97: '0x',
  },
  tradingCompetitionMobox: {
    56: '0x1C5161CdB145dE35a8961F82b065fd1F75C3BaDf',
    97: '0x',
  },
  tradingCompetitionMoD: {
    56: '0xbDd9a61c67ee16c10f5E37b1D0c907a9EC959f33',
    97: '0x',
  },
  easterNft: {
    56: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    97: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  selfVault: {
    56: '0x54eff9d9539206514fbc2e5b00fbe4168fad4aa0', // ours
    97: '0x2c8CC26b700e87B068ef06EF618125eE1b287b98', // ours
  },
  selfFlexibleSideVault: {
    56: '0x61aed69b75a935c9ae58febb9ff7c151b159997e', // ours
    97: '0x',
  },
  predictionsBNB: {
    56: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    97: '0x',
  },
  predictionsCAKE: {
    56: '0x0E3A8078EDD2021dadcdE733C6b4a86E51EE8f07',
    97: '0x',
  },
  chainlinkOracleBNB: {
    56: '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE', // 0xD276fCF34D54A926773c399eBAa772C12ec394aC
    97: '0x',
  },
  chainlinkOracleCAKE: {
    56: '0xB6064eD41d4f67e353768aA239cA86f4F73665a1',
    97: '0x',
  },
  predictionsV1: {
    56: '0x516ffd7d1e0ca40b1879935b2de87cb20fc1124b',
    97: '0x',
  },
  bunnySpecialCakeVault: {
    56: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    97: '0x',
  },
  bunnySpecialPrediction: {
    56: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    97: '0x',
  },
  bunnySpecialLottery: {
    56: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    97: '0x382cB497110F398F0f152cae82821476AE51c9cF',
  },
  bunnySpecialXmas: {
    56: '0x59EdDF3c21509dA3b0aCCd7c5ccc596d930f4783',
    97: '0x',
  },
  farmAuction: {
    56: '0x777f64eb6dd46c2d9b7e3e4fa786865f984ca704', // ours
    97: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
  },
  nftMarket: {
    56: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    97: '0x7f9f37ddcaa33893f9beb3d8748c8d6bfbde6ab2',
  },
  nftSale: {
    56: '0x29fE7148636b7Ae0b1E53777b28dfbaA9327af8E',
    97: '0xe486De509c5381cbdBF3e71F57D7F1f7570f5c46',
  },
  pancakeSquad: {
    56: '0x0a8901b0E25DEb55A87524f0cC164E9644020EBA',
    97: '0xfC0c3F11fDA72Cb9A56F28Ec8D44C0ae4B3ABF86',
  },
  potteryDraw: {
    56: '0x01871991587d5671f3A2d4E2BcDC22F4E026396e',
    97: '0xDB9D365b50E62fce747A90515D2bd1254A16EbB9',
  },
  zap: {
    56: '0x012228198e9c30cc3f20f49295f998a32a15d2eb', // ours
    97: '0xD85835207054F25620109bdc745EC1D1f84F04e1',
  },
  stableSwapNativeHelper: {
    56: '0x52E5D1e24A4308ef1A221C949cb2F7cbbAFEE090',
    97: '0x6e4B1D7C65E86f1723720a5fE8993f0908108b64',
  },  
  iSELF: {
    56: '0x33339a4b2e81286afcbe91f12ecc7c290e08e4db',  // ours
    97: '0x',
  },
  bCakeFarmBooster: {
    56: '0x926E604b4be3030Ae78067E7213C081D7a1E350e', // ours
    97: '0x',
  },
  bCakeFarmBoosterProxyFactory: {
    56: '0xd9442211e791eaddb0eb85c5834fc9fdc48a05fc', // ours
    97: '0x',
  },
  bSelfFarmBoosterV3: {
    56: '0xAdc6D668213761477F017fA72d17ac8d21E9316a', // ours
    97: '0x56666300A1E25624489b661f3C6c456c159a109a',
  },  
  nonBscVault: {
    1: '0x2e71B2688019ebdFDdE5A45e6921aaebb15b25fb',
    5: '0xE6c904424417D03451fADd6E3f5b6c26BcC43841',
  },
  crossFarmingSender: {
    1: '0x8EA90Ef07f37c77137453C7A1B72B7886d51eCFb',
    5: '0x327d26dE30f92600620A99043034e0A5FD9402C8',
  },
  crossFarmingReceiver: {
    56: '0x0726a8C8206b9eC0AfB788df5adb36a8AEDB13c2',
    97: '0xBab5d3B6bA24E185f216419f3ba07f03984bF983',
  },
  mmLinkedPool: {
    1: '0x9Ca2A439810524250E543BA8fB6E88578aF242BC',
    5: '0x7bb894Ca487568dD55054193c3238d7B1f46BB92',
    56: '0xfEACb05b373f1A08E68235bA7FC92636b92ced01',
  },
  tradingReward: {
    1: '0x',
    56: '0xa842a4AD40FEbbd034fbeF25C7a880464a90e695',
    97: '0x',
  },  
  nftPositionManager: {
    1: '0x46A15B0b27311cedF172AB29E4f4766fbE7F4364',
    5: '0x427bF5b37357632377eCbEC9de3626C71A5396c1',
    56: '0x861Df60F27070E60E094763c73B4ff3A89CfeE9e', // ours
    97: '0x427bF5b37357632377eCbEC9de3626C71A5396c1',
    280: '0xF84697CfE7c88F846e4ba5dAe14A6A8f67deF5c2',
    324: '0xa815e2eD7f7d5B0c49fda367F249232a1B9D2883',
    1101: '0x46A15B0b27311cedF172AB29E4f4766fbE7F4364',
    1442: '0x1f489dd5B559E976AE74303F939Cfd0aF1b62C2B',
    42161: '0x46A15B0b27311cedF172AB29E4f4766fbE7F4364',
    59140: '0xacFa791C833120c769Fd3066c940B7D30Cd8BC73',
    421613: '0xb10120961f7504766976A89E29802Fa00553da5b',
  },
  v3PoolDeployer: DEPLOYER_ADDRESSES, // ours
  v3Migrator: {
    1: '0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2',
    5: '0x46A15B0b27311cedF172AB29E4f4766fbE7F4364',
    56: '0xDf503e52024800ee9aAd859C7047C0D46F0792C1', // ours
    97: '0x46A15B0b27311cedF172AB29E4f4766fbE7F4364',
    280: '0x7627931617A60Fe58EDBf4881ac166E1eDe2379e',
    324: '0x556A72A7A3bB3bbd293D923e59b6B56898fB405D',
    1101: '0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2',
    1442: '0x4A3902773F947ce028969db670E568fFC9524E8C',
    42161: '0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2',
    59140: '0x3652Fc6EDcbD76161b8554388867d3dAb65eCA93',
    421613: '0xCcf770BdBD8ccC57a7a7ABff53825fD895a06238',    
  },
  quoter: V3_QUOTER_ADDRESSES, // ours
  affiliateProgram: {
    1: '0x',
    56: '0x92C73D90F709DFf7e5E7307e8F2EE20e39396b12',
    97: '0x1B8a475B5E5De05fB3Ac2D9ec3C2809fBF24e51c',
  },
  tradingRewardTopTrades: {
    1: '0x',
    56: '0x549d484F493b778A5c70638E30Fc6Dc6B2Dcc4c0',
    97: '0x',
  },  
} as const satisfies Record<string, Record<number, `0x${string}`>>